import { createAction, props } from '@ngrx/store';

export const getUsersList = createAction(
  '[MyOrganization/API] Get users list',
  props<{ usersPayload: any; pathName?: any }>()
);
export const getUsersListSuccess = createAction(
  '[MyOrganization/API] Get users list success',
  props<{ usersList: any }>()
);
export const getUsersListFailure = createAction(
  '[MyOrganization/API] Get users list failure',
  props<{ error: any }>()
);

//Actions for getting My teams list
export const getManageTeamsList = createAction(
  '[MyOrganization/API] Get teams list',
  props<{ teamsPayload: any; pathName?: any }>()
);
export const getManageTeamsListSuccess = createAction(
  '[MyOrganization/API] Get teams list success',
  props<{ teamsPayload: any }>()
);
export const getManageTeamsListFailure = createAction(
  '[MyOrganization/API] Get teams list Failure',
  props<{ error: any }>()
);

//Action for invoking and handling delete action in My organization Data grids
export const openMyOrgDeleteModal = createAction(
  '[MyOrganization/API] openMyOrgDeleteModal',
  props<{ id: any; managetype: any; valueName: any }>()
);

// Action for deleteing My organization data
export const deleteManageData = createAction(
  '[MyOrganization/API] deleteManageData',
  props<{ payload: any; managetype: any; valueName: any }>()
);
export const deleteManageDataSuccess = createAction(
  '[MyOrganization/API] deleteManageData Success',
  props<{ deleteManageDataMessage: any }>()
);
export const deleteManageDataFailure = createAction(
  '[MyOrganization/API] deleteManageData Failure',
  props<{ error: any }>()
);

//Action for getting project workflow data
export const getProjectWorkflowList = createAction(
  '[MyOrganization/API] Get PorjectWorkflow list',
  props<{ projectWorkflowPayload: any }>()
);
export const getProjectWorkflowListSuccess = createAction(
  '[MyOrganization/API] Get PorjectWorkflow list success',
  props<{ projectWorkflowList: any }>()
);
export const getProjectWorkflowListFailure = createAction(
  '[MyOrganization/API] Get PorjectWorkflow list failure',
  props<{ error: any }>()
);
// Action for Manage scenario workflow
export const getManageScenarioWorkflowList = createAction(
  '[MyOrganization/API] Get manageScenarioWorkFlow list',
  props<{ manageScenarioWorkflowPayload: any }>()
);
export const getManageScenarioWorkflowSuccess = createAction(
  '[MyOrganization/API] Get manageScenarioWorkFlow success',
  props<{ manageScenarioWorkflowList: any }>()
);
export const getManageScenarioWorkflowFailure = createAction(
  '[MyOrganization/API] Get manageScenarioWorkFlow failure',
  props<{ error: any }>()
);

//Action for getting Product Groups list
export const getProductGroupsList = createAction(
  '[MyOrganization/API] Get Product Groups list',
  props<{ productGroupsPayload: any }>()
);
export const getProductGroupsListSuccess = createAction(
  '[MyOrganization/API] Get Product Groups list success',
  props<{ ProductGroupsList: any }>()
);
export const getProductGroupsListFailure = createAction(
  '[MyOrganization/API] Get Product Groups list failure',
  props<{ error: any }>()
);

export const resendConfirmationMail = createAction(
  '[MyOrganization/API] resend mail',
  props<{ emailData: any; url: any }>()
);
export const resendConfirmationMailSuccess = createAction(
  '[MyOrganization/API] resend mail success',
  props<{ responseData: any }>()
);

export const manualActivateUser = createAction(
  '[MyOrganization/API] manualActivateUser',
  props<{ emailData: any }>()
);
export const manualActivateUserSuccess = createAction(
  '[MyOrganization/API] manualActivateUser success',
  props<{ responseData: any }>()
);

//Action for getting Supplier list in Organization preferences
export const getSupplierList = createAction(
  '[MyOrganization/API] Get supplier list index',
  props<{ supplierListPayload: any }>()
);
export const getSupplierListSuccess = createAction(
  '[MyOrganization/API] Get supplier list success',
  props<{ SupplierList: any }>()
);
export const getSupplierListFailure = createAction(
  '[MyOrganization/API] Get supplier list failure',
  props<{ error: any }>()
);

//Action for getting Custom Category Organization preferences
export const getCustomCategoryList = createAction('[MyOrganization/API] Get Custom Category list');
export const getCustomCategoryListSuccess = createAction(
  '[MyOrganization/API] Get Custom Category list',
  props<{ customCategoryList: any }>()
);

//Action for getting Litter Impact Data in Organization preferences
export const getLitterImpactData = createAction('[MyOrganization/API] Get litter impact List');
export const getLitterImpactDataSuccess = createAction(
  '[MyOrganization/API] Get litter impact List Success',
  props<{ litterImpactData: any }>()
);

//Action for getting Organization Year Ends on data in Organization preferences
export const getYearEndsOnData = createAction('[MyOrganization/API] Get yearEndsOnData');
export const getYearEndsOnDataSuccess = createAction(
  '[MyOrganization/API] Get yearEndsOnData Success',
  props<{ yearEndsOnData: any }>()
);

//Action for getting Custom Speedos data in Organization preferences
export const getCustomSpeedosData = createAction('[MyOrganization/API] Get getCustomSpeedosData');
export const getCustomSpeedosDataSuccess = createAction(
  '[MyOrganization/API] Get getCustomSpeedosData Success',
  props<{ customSpeedosData: any }>()
);

//Action for getting Custom Packaging Metrics data in Organization preferences
export const getPackagingMetricsData = createAction(
  '[MyOrganization/API] Get getPackagingMetricsData'
);
export const getPackagingMetricsDataSuccess = createAction(
  '[MyOrganization/API] Get getPackagingMetricsData Success',
  props<{ packagingMetricsData: any }>()
);

//Action for getting Project Saving Logs list
export const getProjectSavingLogsList = createAction(
  '[MyOrganization/API] Get Project Saving Logs list',
  props<{ projectSavingLogsPayload: any }>()
);
export const getProjectSavingLogsListSuccess = createAction(
  '[MyOrganization/API] Get Project Saving Logs list success',
  props<{ ProjectSavingLogsList: any }>()
);
export const getProjectSavingLogsListFailure = createAction(
  '[MyOrganization/API] Get Project Saving Logs list failure',
  props<{ error: any }>()
);

//Action for Getting SSO Group List
export const getSSOGroupList = createAction(
  '[MyOrganization/API] Get get SSO Group list',
  props<{ ssoGroupPayload: any }>()
);
export const getSSOGroupListSuccess = createAction(
  '[MyOrganization/API] Get get SSO Group list success',
  props<{ ssoGroupList: any }>()
);
export const getSSOGroupListFailure = createAction(
  '[MyOrganization/API] Get get SSO Group list failure',
  props<{ error: any }>()
);

//Action for opening add/edit SSO Group modal
export const openAddEditSSOGroupModal = createAction(
  '[MyOrganization/API] openAddEditSSOGroupModal',
  props<{ groupId: any; ssoData: any; actionLabel: any }>()
);
export const openAddEditSSOGroupModalSuccess = createAction(
  '[MyOrganization/API] openAddEditSSOGroupModal Success',
  props<{ ssoGroupdata?: any }>()
);

export const addEditSSOGroup = createAction(
  '[MyOrganization/API] addEditSSOGroup',
  props<{ ssoGroupData: any }>()
);
export const addEditSSOGroupSuccess = createAction(
  '[MyOrganization/API] addEditSSOGroup Success',
  props<{ ssoGroupData: any }>()
);

// opening add/edit custom organization manage user modal
export const openAddEditMyOrganizationManageUserModal = createAction(
  '[MyOrganization/API] Open Add edit my organization manage user Modal',
  props<{ myOrganizationManageUserId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditMyOrganizationManageUserModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit organization manage user Modal success',
  props<{ myOrganizationManagageUserData?: any }>()
);

//Action for Manage User For Add
export const myOrganizationManageUser = createAction(
  '[MyOrganization/API] myOrganizationManageUser',
  props<{ myOrganizationManageUserData: any }>()
);
export const myOrganizationManageUserSuccess = createAction(
  '[MyOrganization/API] myOrganizationManageUser success',
  props<{ saveManageUserData: any }>()
);
export const myOrganizationManageUserFailure = createAction(
  '[MyOrganization/API] myOrganizationManageUser failure',
  props<{ error: any }>()
);

//Action for Manage User For Edit
export const myOrganizationManageUserForEdit = createAction(
  '[MyOrganization/API] myOrganizationManageUserForEdit',
  props<{ myOrganizationManageUserData: any }>()
);
export const myOrganizationManageUserForEditSuccess = createAction(
  '[MyOrganization/API] myOrganizationManageUserForEdit success',
  props<{ saveManageUserData: any }>()
);
export const myOrganizationManageUserForEditFailure = createAction(
  '[MyOrganization/API] myOrganizationManageUserForEdit failure',
  props<{ error: any }>()
);
//Action for Manage Teams Add/Edit
export const openAddEditMyTeamsModal = createAction(
  '[MyOrganization/API] Open Add edit my teams Modal',
  props<{ myTeamsId?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditMyTeamsModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit my teams Modal success',
  props<{ myTeamsData?: any }>()
);

export const addEditMyTeams = createAction(
  '[MyOrganization/API] Add edit my teams',
  props<{ myTeamsData: any }>()
);
export const addEditMyTeamsSuccess = createAction(
  '[MyOrganization/API] Add edit my teams success',
  props<{ myTeamsData: any }>()
);
export const addEditMyTeamsFailure = createAction(
  '[MyOrganization/API] Add edit my teams failure',
  props<{ error: any }>()
);

//Action for Manage Product Groups Add/Edit
export const openAddEditManageProductsModal = createAction(
  '[MyOrganization/API] Open Add edit Manage Product Groups Modal',
  props<{ manageProductGroupsId?: any; headerName: any }>()
);
export const openAddEditManageProductsModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit Manage Product Groups Modal success',
  props<{ manageProductGroupsData?: any }>()
);

export const addEditManageProducts = createAction(
  '[MyOrganization/API] Add edit Manage Product Groups',
  props<{ manageProductGroupsData: any }>()
);
export const addEditManageProductsSuccess = createAction(
  '[MyOrganization/API] Add edit Manage Product Groups success',
  props<{ manageProductGroupsData: any }>()
);
export const addEditManageProductsFailure = createAction(
  '[MyOrganization/API] Add edit Manage Product Groups failure',
  props<{ error: any }>()
);

//Actions for Manage Project Workflow ADD/EDIT
export const openAddEditProjectWorkFlowModal = createAction(
  '[MyOrganization/API] Open Add edit Manage Project Workflow Modal',
  props<{ manageProjectWorkflowId?: any; headerName: any }>()
);
export const openAddEditProjectWorkFlowModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit Manage Project Workflow Modal success',
  props<{ manageProjectWorkflowData?: any }>()
);

export const addEditProjectWorkFlow = createAction(
  '[MyOrganization/API] Add edit Manage Project Workflow',
  props<{ manageProjectWorkFlowData: any }>()
);
export const addEditProjectWorkFlowSuccess = createAction(
  '[MyOrganization/API] Add edit Manage Project Workflow success',
  props<{ manageProjectWorkFlowData: any }>()
);
export const addEditProjectWorkFlowFailure = createAction(
  '[MyOrganization/API] Add edit Manage Project Workflow failure',
  props<{ error: any }>()
);

//Actions for Manage scenario Workflow ADD/EDIT
export const openAddEditScenarioWorkFlowModal = createAction(
  '[MyOrganization/API] Open Add edit Manage scenario Workflow Modal',
  props<{ manageScenarioWorkflowId?: any; headerName: any }>()
);
export const openAddEditScenarioWorkFlowModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit Manage scenario Workflow Modal success',
  props<{ manageScenarioWorkflowData?: any }>()
);

export const addEditScenarioWorkFlow = createAction(
  '[MyOrganization/API] Add edit Manage scenario Workflow',
  props<{ manageScenarioWorkFlowData: any }>()
);
export const addEditScenarioWorkFlowSuccess = createAction(
  '[MyOrganization/API] Add edit Manage scenario Workflow success',
  props<{ manageScenarioWorkFlowData: any }>()
);
export const addEditScenarioWorkFlowFailure = createAction(
  '[MyOrganization/API] Add edit Manage scenario Workflow failure',
  props<{ error: any }>()
);

//Actions for List of Suppliers (Org. prefrences) ADD/EDIT
export const openAddEditSupplierModal = createAction(
  '[MyOrganization/API] Open Add edit List of Suppliers Modal',
  props<{ supplierId?: any; headerName: any }>()
);
export const openAddEditSupplierModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit List of Suppliers Modal success',
  props<{ supplierData?: any }>()
);

export const addEditSupplier = createAction(
  '[MyOrganization/API] Add edit supplier',
  props<{ supplierData: any }>()
);
export const addEditSupplierSuccess = createAction(
  '[MyOrganization/API] Add edit supplier success',
  props<{ supplierData: any }>()
);
export const addEditSupplierFailure = createAction(
  '[MyOrganization/API] Add edit supplier failure',
  props<{ error: any }>()
);

//Actions for Org. Year end (Org. prefrences) EDIT
export const openAddEditOrgYearEndModal = createAction(
  '[MyOrganization/API] Open edit Org. Year end Modal',
  props<{ orgYearEndId?: any; headerName: any }>()
);
export const openAddEditOrgYearEndModalSuccess = createAction(
  '[MyOrganization/API] Open edit Org. Year end Modal success',
  props<{ orgYearEndData?: any }>()
);

export const editOrgYearEnd = createAction(
  '[MyOrganization/API] Add edit Org. Year end',
  props<{ orgYearEndData: any }>()
);
export const editOrgYearEndSuccess = createAction(
  '[MyOrganization/API] Add edit Org. Year end success',
  props<{ orgYearEndData: any }>()
);
export const editOrgYearEndFailure = createAction(
  '[MyOrganization/API] Add edit Org. Year end failure',
  props<{ error: any }>()
);

//Action for custom speedos(Org. prefrences) EDIT
export const openEditCustomSpeedosModal = createAction(
  '[MyOrganization/API] Open edit Org. speedos Modal',
  props<{ customSpeedosId?: any; headerName: any }>()
);
export const openEditCustomSpeedosModalSuccess = createAction(
  '[MyOrganization/API] Open edit Org. speedos Modal success',
  props<{ customSpeedosData?: any }>()
);

export const editCustomSpeedos = createAction(
  '[MyOrganization/API] edit Org. speedos',
  props<{ customSpeedosData: any }>()
);
export const editCustomSpeedosSuccess = createAction(
  '[MyOrganization/API] edit Org. speedos success',
  props<{ customSpeedosData: any }>()
);
export const editCustomSpeedosFailure = createAction(
  '[MyOrganization/API] edit Org. speedos failure',
  props<{ error: any }>()
);

//Action for packaging metric (Org. prefrences) EDIT
export const openEditPackagingMetricsModal = createAction(
  '[MyOrganization/API] Open edit Org. packaging metric Modal',
  props<{ packagingMetricsId?: any; headerName: any }>()
);
export const openEditPackagingMetricsModalSuccess = createAction(
  '[MyOrganization/API] Open edit Org. packaging metric Modal success',
  props<{ packagingMetricsData?: any }>()
);

export const editpackagingMetrics = createAction(
  '[MyOrganization/API] edit Org. packaging metric',
  props<{ packagingMetricsData: any }>()
);
export const editpackagingMetricsSuccess = createAction(
  '[MyOrganization/API] edit Org. packaging metric success',
  props<{ packagingMetricsData: any }>()
);
export const editpackagingMetricsFailure = createAction(
  '[MyOrganization/API] edit Org. packaging metric failure',
  props<{ error: any }>()
);

//Action for custom category (Org. prefrences) EDIT
export const openEditCustomCategoryModal = createAction(
  '[MyOrganization/API] Open edit Org. custom category Modal',
  props<{ customCategoryId?: any; headerName: any }>()
);
export const openEditCustomCategoryModalSuccess = createAction(
  '[MyOrganization/API] Open edit Org. custom category Modal success',
  props<{ customCategoryData?: any }>()
);

export const editCustomCategory = createAction(
  '[MyOrganization/API] edit Org. custom category',
  props<{ customCategoryData: any }>()
);
export const editCustomCategorySuccess = createAction(
  '[MyOrganization/API] edit Org. custom category success',
  props<{ customCategoryData: any }>()
);
export const editCustomCategoryFailure = createAction(
  '[MyOrganization/API] edit Org. custom category failure',
  props<{ error: any }>()
);

//Action for litter impact EDIT
export const openEditLitterImpactModal = createAction(
  '[MyOrganization/API] Open edit Org. litter impact Modal',
  props<{ litterImpactId?: any; headerName: any }>()
);
export const openEditLitterImpactModalSuccess = createAction(
  '[MyOrganization/API] Open edit Org. litter impact Modal success',
  props<{ litterImpactFormData?: any }>()
);
export const updateLitterImpactData = createAction(
  '[MyOrganization/API] Update litter impact data',
  props<{ eolListItem: any }>()
);

export const editLitterImpact = createAction(
  '[MyOrganization/API] edit Org. litter impact',
  props<{ litterImpactData: any }>()
);
export const editLitterImpactSuccess = createAction(
  '[MyOrganization/API] edit Org. litter impact success',
  props<{ litterImpactData: any }>()
);
export const editLitterImpactFailure = createAction(
  '[MyOrganization/API] edit Org. litter impact failure',
  props<{ error: any }>()
);

//Action for getting User Details
export const getManageUserDetailsList = createAction(
  '[MyOrganization/API] Get Manage User details list',
  props<{ manageUserDetailsPayload: any; id: any }>()
);
export const getManageUserDetailsListSuccess = createAction(
  '[MyOrganization/API] Get Manage User details list success',
  props<{ manageUserDetailsList: any }>()
);
export const getManageUserDetailsListFailure = createAction(
  '[MyOrganization/API] Get Manage User details Failure',
  props<{ error: any }>()
);

export const getManageUserTeamMemberShipGridData = createAction(
  '[MyOrganization/API] Get Manage User team membership details list',
  props<{ manageTeamMembershipPayload: any; id: any }>()
);
export const getManageUserTeamMemberShipGridDataSuccess = createAction(
  '[MyOrganization/API] Get team membership details list',
  props<{ manageTeamMembershipList: any }>()
);
export const getManageUserTeamMemberShipGridDataFailure = createAction(
  '[MyOrganization/API] Get team membership details Failure',
  props<{ error: any }>()
);

export const getAdminOrganizationMemberShipGridData = createAction(
  '[MyOrganization/API] getAdminOrganizationMemberShipGridData',
  props<{ adminOrganizationMembershipPayload: any; id?: any }>()
);
export const getAdminOrganizationMemberShipGridDataSuccess = createAction(
  '[MyOrganization/API] getAdminOrganizationMemberShipGridDataSuccess',
  props<{ adminOrganizationMembershipList: any }>()
);
export const getAdminOrganizationMemberShipGridDataFailure = createAction(
  '[MyOrganization/API] getAdminOrganizationMemberShipGridDataFailure',
  props<{ error: any }>()
);

export const getTeamGridData = createAction(
  '[MyOrganization/API] Get Manage User team details list',
  props<{ manageTeamPayload: any; id: any }>()
);
export const getTeamGridDataSuccess = createAction(
  '[MyOrganization/API] Get team details list',
  props<{ manageTeamList: any }>()
);
export const getTeamGridDataFailure = createAction(
  '[MyOrganization/API] Get team details Failure',
  props<{ error: any }>()
);

//Actions for organization membership
export const openAddEditOrganizationModal = createAction(
  '[MyOrganization/API] Open Add edit Organization Modal',
  props<{ id?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditOrganizationModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit Organization Modal success',
  props<{ organizationData?: any }>()
);

export const addUpdateOrganizationTeamMembership = createAction(
  '[MyOrganization/API] Add edit Organization Team list',
  props<{ manageOrganizationTeamData: any }>()
);
export const addUpdateOrganizationTeamMembershipSuccess = createAction(
  '[MyOrganization/API] Add edit Organization Team Workflow success',
  props<{ manageOrganizationTeamData: any }>()
);
export const addUpdateOrganizationTeamMembershipFailure = createAction(
  '[MyOrganization/API] Add edit Organization Team Workflow failure',
  props<{ error: any }>()
);

//Actions for team membership (Manage Users)
export const openAddEditUsersTeamMembershipModal = createAction(
  '[MyOrganization/API] Open Add edit team membership Modal',
  props<{ id?: any; userId: any; actionLabel: any }>()
);
export const openAddEditUsersTeamMembershipModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit team membership Modal success',
  props<{ teamMembershipData?: any }>()
);

export const addUpdateUsersTeamMembership = createAction(
  '[MyOrganization/API] Add edit team membership list',
  props<{ manageTeamMembershipData: any }>()
);
export const addUpdateUsersTeamMembershipSuccess = createAction(
  '[MyOrganization/API] Add edit team membership Workflow success',
  props<{ manageTeamMembershipData: any }>()
);
export const addUpdateUsersTeamMembershipFailure = createAction(
  '[MyOrganization/API] Add edit team membership Workflow failure',
  props<{ error: any }>()
);

//Actions for team membership (Manage Teams)
export const openAddEditTeamsTeamMembershipModal = createAction(
  '[MyOrganization/API] Open Add edit Teams team membership Modal',
  props<{ id?: any; teamId: any; actionLabel: any; orgnizationId?: any }>()
);
export const openAddEditTeamsTeamMembershipModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit Teams team membership Modal success',
  props<{ teamMembershipData?: any }>()
);
//Actions for organization membership
export const openAddEditAdminOrganizationMembershipModal = createAction(
  '[MyOrganization/API] Open Add edit Admin organization membership Modal',
  props<{ id?: any; actionLabel: any; pathName: any }>()
);
export const openAddEditAdminOrganizationMembershipModalSuccess = createAction(
  '[MyOrganization/API] Open Add edit Admin organization membership Modal success',
  props<{ adminOrganizationMembershipData?: any }>()
);

export const addUpdateTeamMembership = createAction(
  '[MyOrganization/API] Add edit Teams team membership list',
  props<{ manageTeamMembershipData: any }>()
);
export const addUpdateTeamMembershipSuccess = createAction(
  '[MyOrganization/API] Add edit Teams team membership Workflow success',
  props<{ manageTeamMembershipData: any }>()
);
export const addUpdateTeamMembershipFailure = createAction(
  '[MyOrganization/API] Add edit Teams team membership Workflow failure',
  props<{ error: any }>()
);

export const deleteTeamsTeamMembership = createAction(
  '[MyOrganization/API] Delete Teams team membership list',
  props<{ id: any }>()
);
export const deleteTeamsTeamMembershipSuccess = createAction(
  '[MyOrganization/API] Delete Teams team membership Workflow success',
  props<{ deleteTeamMembershipData: any }>()
);
export const deleteTeamsTeamMembershipFailure = createAction(
  '[MyOrganization/API] Delete Teams team membership Workflow failure',
  props<{ error: any }>()
);

export const getPaymentTransaction = createAction(
  '[MyOrganization/API] getPaymentTransaction',
  props<{ paymentTransactionPayload: any }>()
);
export const getPaymentTransactionSuccess = createAction(
  '[MyOrganization/API] getPaymentTransactionSuccess',
  props<{ paymentTransactionList: any }>()
);
export const getPaymentTransactionFailure = createAction(
  '[MyOrganization/API] getPaymentTransactionFailure',
  props<{ error: any }>()
);

//Action for opening add/edit Login Logsmodal
export const openInvoiceModal = createAction(
  '[MyOrganization/API] Open  invoice Modal',
  props<{ transactionId?: any; actionLabel: any }>()
);
export const openInvoiceModalSuccess = createAction(
  '[MyOrganization/API] Open invoice success',
  props<{ invoiceData?: any }>()
);
//Action for download invoice
export const invoiceDownloadData = createAction(
  '[MyOrganization/API] Open invoiceDownloadData',
  props<{ Invoiceid?: any }>()
);
export const invoiceDownloadDataSuccess = createAction(
  '[MyOrganization/API] Open invoiceDownloadData',
  props<{ invoiceDownloadData?: any }>()
);

// Action for Admin Manage user organization membership add edit
export const openAddEditAdminManageUserOrgMembershipModal = createAction(
  '[MyOrganization/API] Admin Manage user organization membership Modal',
  props<{ id?: any; userId?: any; actionLabel: any }>()
);
export const openAddEditAdminManageUserOrgMembershipModalSuccess = createAction(
  '[MyOrganization/API] Admin Manage user organization membership success',
  props<{ data?: any }>()
);

// inline edit admin organization
export const inlineDataEditForOrganizationPref = createAction(
  '[MyOrganization/API] Inline edit organization preferences edit',
  props<{ prefrencesData: any; module: any; pathName: any; nodeId?: any; field?: any }>()
);
export const inlineDataEditForOrganizationPrefSuccess = createAction(
  '[MyOrganization/API] Inline edit organization preferences edit success',
  props<{ prefrencesData: any; module: any; field?: any }>()
);
export const inlineDataEditForOrganizationPrefFailure = createAction(
  '[MyOrganization/API] Inline edit organization preferences edit failure',
  props<{ error: any }>()
);

// GET ORGANIZATION WEIGHTINGS
export const getOrgWeightingsList = createAction(
  '[MyOrganization/API] Get org weightings list',
  props<{ data: any }>()
);
export const getOrgWeightingsListSuccess = createAction(
  '[MyOrganization/API] Get org weightings list success',
  props<{ weightingList: any }>()
);
export const updateOrgWeightingsList = createAction(
  '[MyOrganization/API] Update organization weighting process',
  props<{ process: any; action: any; processIndex?: any; colId?: any }>()
);

// Actions for ADD upload SKU
export const addSKUYearProcess = createAction(
  '[MyOrganization/API] Add SKU year process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const updateSKUYearProcess = createAction(
  '[MyOrganization/API] Update SKU year process',
  props<{ process: any; action: any; processIndex?: any; nodeId?: any; colId?: any }>()
);
export const deleteSKUYearProcess = createAction(
  '[MyOrganization/API] Delete SKU year process',
  props<{ process: any; action: any; processIndex?: any }>()
);
export const SKUYearProcessFailure = createAction(
  '[MyOrganization/API] SKU year process failure',
  props<{ error: any }>()
);
export const patchDataOnOpenSKUModal = createAction(
  '[MyOrganization/API] SKU year process data patch on modal opening',
  props<{ data: any }>()
);
export const clearSKUYearProcess = createAction('[MyOrganization/API] Clear SKU year process');

export const checkUpdateActionSKU = createAction(
  '[custom/API] update action fire for upload SKU',
  props<{ check: boolean }>()
);
export const resetWeightingsList = createAction(
  '[MyOrganization/API] Reset organization weighting process',
  props<{ process: any; action: any }>()
);
